import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const NotificationHeader = ({ onMarkAllRead, unreadCount }) => (
    <Grid container spacing={1.5} alignItems="flex-start" justifyContent="space-between" sx={{ mb: 2 }}>
        <Grid size="grow" className="notification-page-header-intro">
            <Box className="notification-page-header-icon"><NotificationsActiveRoundedIcon /></Box>
            <Box>
                <Box className="notification-page-title-row">
                    <Typography component="h1" className="notification-page-title">Notifications</Typography>
                    {unreadCount > 0 && <Box component="span" className="notification-page-unread-badge">{unreadCount} unread</Box>}
                </Box>
                <Typography className="notification-page-subtitle">Product releases, announcements and important operational updates.</Typography>
            </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 'auto' }} className="notification-page-header-actions">
            {/* <Box component="button" type="button" className="notification-page-settings-btn">
                <SettingsOutlinedIcon />
                Notification settings
            </Box> */}
            <Box component="button" type="button" className="notification-page-mark-read-btn" onClick={onMarkAllRead} disabled={unreadCount === 0}>
                <DoneAllRoundedIcon />
                Mark all as read
            </Box>
        </Grid>
    </Grid>
);

export default NotificationHeader;